<template>
  <div class="service-lock-setting">
    <el-tabs v-model="activeTabName" type="card" style="margin-top: 8px;" @tab-click="handleClick">
      <el-tab-pane :label="$t('CargoMsg.Cargo_ServiceLockSettings')" name="lockSetting">
        <div style="display: flex;padding-left: 8px;padding-top: 8px;">
          <div class="filters">
            <el-form :inline="true" label-width="100px" label-position="right">
              <div class="el-form-item-wrapper">
                <el-form-item label-width="50px" :label="$t('SystemMaintenance.Branch')">
                  <el-select v-model="form.branchId" no="1" filterable @change="changeBranch()">
                    <el-option
                      v-for="office in currentOfficeList"
                      :key="office.officeId"
                      :value="office.officeId"
                      :label="office.code"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item v-show="form.branchId!==1">
                  <el-checkbox v-model="form.useParent" @change="applyHq">{{ $t('CargoMsg.Cargo_GeneralSettings') }}</el-checkbox>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="toSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
                </el-form-item>
              </div>
            </el-form>
            <br>
          </div>
          <div v-if="form.useParent" style="position: absolute; top: 40px; left: 0;right: 0;bottom: 0; background-color: rgba(0,0,0,.2); cursor: not-allowed; z-index: 10" />
          <div class="show-right section" style="width: 60%;background-color: #FFFFFF;">
            <div class="main-content left" style="margin-top: 20px;margin-left: 30px;margin-bottom: 100px;">
              <el-form :inline="true" label-width="100px" label-position="right">
                <div class="el-form-item-wrapper">
                  <el-form-item>
                    <span class="title">{{ $t('CargoMsg.Cargo_AutomaticallyLocksServiceData') }}</span>
                  </el-form-item>
                  <el-form-item>
                    <el-checkbox v-model="form.autoLock" no="2" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_BusinessDate1')" :label-width="isZh?'100px':'150px'">
                    <auto-number-input v-model="form.day" no="3" :min="3" :max="120" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_Days1')" label-width="25px" />
                  <el-form-item>
                    <el-tooltip>
                      <i class="el-icon-warning" style="color: #e6a23c;margin-left: 5px" />
                    </el-tooltip>
                    <label>{{ $t('CargoMsg.Cargo_OnlyServiceDataLocked') }}</label>
                  </el-form-item>
                  <!--                  <el-form-item>-->
                  <!--                    <el-button type="primary" @click="toSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>-->
                  <!--                    <el-button @click="queryHandler">{{ $t('common.btn.cancel') }}</el-button>-->
                  <!--                  </el-form-item>-->
                </div>
                <div class="el-form-item-wrapper" style="margin-top: 20px;">
                  <el-form-item>
                    <span class="title">{{ $t('CargoMsg.Cargo_AutomaticallySubmitServiceData') }}</span>
                  </el-form-item>
                  <el-form-item>
                    <el-checkbox v-model="form.autoSubmit" no="autoSubmit" @change="changeAutoSubmit" />
                  </el-form-item>
                  <el-form-item>
                    <el-tooltip>
                      <i class="el-icon-warning" style="color: #e6a23c;margin-left: 5px" />
                    </el-tooltip>
                    <label>{{ $t('CargoMsg.Cargo_ServicesNotSubmittedAutomaticallySubmitted') }}</label>
                  </el-form-item>
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_OceanExport')">
                    <el-checkbox v-model="form.se" no="se" :disabled="!form.autoSubmit" @change="chargeLobChecked(SystemConstants.SE.code)" />
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="form.seDateType" no="seDateType" :disabled="!(form.autoSubmit && form.se)">
                      <el-option
                        v-for="item in etdDateType"
                        :key="item.code"
                        :label="item.code"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select style="width:100px;" :value="0" no="sePone" :disabled="!(form.autoSubmit && form.se)">
                      <el-option :label="$t('CargoMsg.Cargo_GreaterThan')" :value="0" />
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <auto-number-input v-model="form.seDay" no="seDay" :disabled="!(form.autoSubmit && form.se)" :enforce-min="true" :min="0" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_Days1')" label-width="25px" />
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_OceanImport')">
                    <el-checkbox v-model="form.si" no="si" :disabled="!form.autoSubmit" @change="chargeLobChecked(SystemConstants.SI.code)" />
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="form.siDateType" no="siDateType" :disabled="!(form.autoSubmit && form.si)">
                      <el-option
                        v-for="item in etaDateType"
                        :key="item.code"
                        :label="item.code"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select style="width:100px;" :value="0" no="siPone" :disabled="!(form.autoSubmit && form.si)">
                      <el-option :label="$t('CargoMsg.Cargo_GreaterThan')" :value="0" />
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <auto-number-input v-model="form.siDay" no="siDay" :disabled="!(form.autoSubmit && form.si)" :enforce-min="true" :min="0" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_Days1')" label-width="25px" />
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_AirExport')">
                    <el-checkbox v-model="form.ae" no="ae" :disabled="!form.autoSubmit" @change="chargeLobChecked(SystemConstants.AE.code)" />
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="form.aeDateType" no="aeDateType" :disabled="!(form.autoSubmit && form.ae)">
                      <el-option
                        v-for="item in etdDateType"
                        :key="item.code"
                        :label="item.code"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select style="width:100px;" :value="0" no="aePone" :disabled="!(form.autoSubmit && form.ae)">
                      <el-option :label="$t('CargoMsg.Cargo_GreaterThan')" :value="0" />
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <auto-number-input v-model="form.aeDay" no="aeDay" :disabled="!(form.autoSubmit && form.ae)" :enforce-min="true" :min="0" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_Days1')" label-width="25px" />
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_AirImport')">
                    <el-checkbox v-model="form.ai" no="ai" :disabled="!form.autoSubmit" @change="chargeLobChecked(SystemConstants.AI.code)" />
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="form.aiDateType" no="aiDateType" :disabled="!(form.autoSubmit && form.ai)">
                      <el-option
                        v-for="item in etaDateType"
                        :key="item.code"
                        :label="item.code"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select style="width:100px;" :value="0" no="aiPone" :disabled="!(form.autoSubmit && form.ai)">
                      <el-option :label="$t('CargoMsg.Cargo_GreaterThan')" :value="0" />
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <auto-number-input v-model="form.aiDay" no="aiDay" :disabled="!(form.autoSubmit && form.ai)" :enforce-min="true" :min="0" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_Days1')" label-width="25px" />
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_RailwayExport')">
                    <el-checkbox v-model="form.re" no="re" :disabled="!form.autoSubmit" @change="chargeLobChecked(SystemConstants.RE.code)" />
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="form.reDateType" no="reDateType" :disabled="!(form.autoSubmit && form.re)">
                      <el-option
                        v-for="item in etdDateType"
                        :key="item.code"
                        :label="item.code"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select style="width:100px;" :value="0" no="rePone" :disabled="!(form.autoSubmit && form.re)">
                      <el-option :label="$t('CargoMsg.Cargo_GreaterThan')" :value="0" />
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <auto-number-input v-model="form.reDay" no="reDay" :disabled="!(form.autoSubmit && form.re)" :enforce-min="true" :min="0" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_Days1')" label-width="25px" />
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_RailwayImport')">
                    <el-checkbox v-model="form.ri" no="ri" :disabled="!form.autoSubmit" @change="chargeLobChecked(SystemConstants.RI.code)" />
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="form.riDateType" no="riDateType" :disabled="!(form.autoSubmit && form.ri)">
                      <el-option
                        v-for="item in etdDateType"
                        :key="item.code"
                        :label="item.code"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select style="width:100px;" :value="0" no="riPone" :disabled="!(form.autoSubmit && form.ri)">
                      <el-option :label="$t('CargoMsg.Cargo_GreaterThan')" :value="0" />
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <auto-number-input v-model="form.riDay" no="riDay" :disabled="!(form.autoSubmit && form.ri)" :enforce-min="true" :min="0" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_Days1')" label-width="25px" />
                </div>

                <!--  财务自动锁单功能   -->
                <div class="el-form-item-wrapper" style="margin-top: 20px;">
                  <el-form-item>
                    <span class="title">{{ $t('CargoMsg.Cargo_AutoFinanceAuditLockOrder') }}</span>
                  </el-form-item>
                  <el-form-item>
                    <el-checkbox v-model="form.autoFinanceSubmit" no="autoFinanceSubmit" @change="changeFinanceAutoSubmit" />
                  </el-form-item>
                  <el-form-item>
                    <el-tooltip>
                      <i class="el-icon-warning" style="color: #e6a23c;margin-left: 5px" />
                    </el-tooltip>
                    <label>{{ $t('CargoMsg.Cargo_UnSubmittedBusinessLockOrder') }}</label>
                  </el-form-item>
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item>
                    <div style="display: flex">
                      <el-button type="primary" :disabled="!form.autoFinanceSubmit" @click="toFinanceAdd">{{ $t('CargoMsg.Cargo_add') }}</el-button>
                      <el-button type="danger" :disabled="!form.autoFinanceSubmit" @click="toFinanceDelete">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
                    </div>
                  </el-form-item>
                </div>
                <div v-for="(item,index) in financeSetting" :key="index">
                  <div class="scrollable-div">
                    <div>
                      <el-form-item :label="$t('CargoMsg.Cargo_PollingFrequency')" label-width="125px">
                        <el-select v-model="item.pollingFrequency" style="width:150px;" no="sePone" :disabled="!form.autoFinanceSubmit">
                          <el-option :label="$t('CargoMsg.Cargo_DailyOnce')" :value="0" />
                          <el-option :label="$t('CargoMsg.Cargo_SpecificDateMonthly')" :value="1" />
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <auto-number-input v-show="item.pollingFrequency" v-model="item.financeDay" style="width: 100px;" no="financeDay" :disabled="!form.autoFinanceSubmit" :enforce-min="true" :min="0" />
                      </el-form-item>
                      <el-form-item :label="' '" :label-width="item.pollingFrequency ?'120px':'220px'">
                        <el-checkbox v-model="item.checked" no="ri" :disabled="!form.autoFinanceSubmit">{{ $t('CargoMsg.Cargo_Priority') + item.num }}</el-checkbox>
                      </el-form-item>
                    </div>
                    <div>
                      <el-form-item :label="$t('CargoMsg.Cargo_IncoTerm')" label-width="125px">
                        <cargo-advance-select
                          no="incoTerm"
                          filterable
                          :select-type="selectTypeNames.basic_data_ChargeItem"
                          :default-multiple-value="item.incoTerm"
                          tag-value="code"
                          tag-name="code"
                          :multiple="true"
                          :cache="false"
                          :static-options="incoTermList"
                          style="width: 150px"
                          @parentCallBack="p=>item.incoTerm=p.value"
                        />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_CustomJobType')" label-width="110px">
                        <cargo-advance-select
                          no="customJobType"
                          filterable
                          :select-type="selectTypeNames.basic_data_CutomJobType"
                          :default-multiple-value="item.customJobType"
                          tag-value="code"
                          tag-name="code"
                          :multiple="true"
                          style="width: 150px"
                          @parentCallBack="p=>item.customJobType=p.value"
                        />
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('CargoMsg.Cargo_OceanExport')">
                        <el-checkbox v-model="item.se" no="se" :disabled="!form.autoFinanceSubmit" @change="chargeFinanceLobChecked(SystemConstants.SE.code, item)" />
                      </el-form-item>
                      <el-form-item>
                        <el-select v-model="item.seDateType" no="seDateType" style="width:100px;" :disabled="!(form.autoFinanceSubmit && item.se)">
                          <el-option
                            v-for="item in financeEtdDateType"
                            :key="item.code"
                            :label="item.code"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <el-select style="width:100px;" :value="0" no="sePone" :disabled="!(form.autoFinanceSubmit && item.se)">
                          <el-option :label="$t('CargoMsg.Cargo_GreaterThan')" :value="0" />
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <auto-number-input v-model="item.seDay" style="width: 100px;" no="seDay" :disabled="!(form.autoFinanceSubmit && item.se)" :enforce-min="true" :min="0" />
                      </el-form-item>
                      <el-form-item>
                        <el-select v-model="item.seDayUnit" no="seDayUnit" style="width:70px;" :disabled="!(form.autoFinanceSubmit && item.se)">
                          <el-option :label="$t('CargoMsg.Cargo_Days')" :value="0" />
                          <el-option :label="$t('CargoMsg.Cargo_Month')" :value="1" />
                        </el-select>
                        <el-tooltip v-if="item.seDayUnit === 1" :content="$t('CargoMsg.Cargo_FinanceMonthUnitTip')" placement="top">
                          <i class="el-icon-warning" style="margin-left: 2px;color: #E6A23C;font-size: 14px;" />
                        </el-tooltip>
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('CargoMsg.Cargo_OceanImport')">
                        <el-checkbox v-model="item.si" no="si" :disabled="!form.autoFinanceSubmit" @change="chargeFinanceLobChecked(SystemConstants.SI.code, item)" />
                      </el-form-item>
                      <el-form-item>
                        <el-select v-model="item.siDateType" no="siDateType" style="width:100px;" :disabled="!(form.autoFinanceSubmit && item.si)">
                          <el-option
                            v-for="item in financeAtdDateType"
                            :key="item.code"
                            :label="item.code"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <el-select style="width:100px;" :value="0" no="siPone" :disabled="!(form.autoFinanceSubmit && item.si)">
                          <el-option :label="$t('CargoMsg.Cargo_GreaterThan')" :value="0" />
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <auto-number-input v-model="item.siDay" style="width: 100px;" no="siDay" :disabled="!(form.autoFinanceSubmit && item.si)" :enforce-min="true" :min="0" />
                      </el-form-item>
                      <el-form-item>
                        <el-select v-model="item.siDayUnit" no="siDayUnit" style="width:70px;" :disabled="!(form.autoFinanceSubmit && item.si)">
                          <el-option :label="$t('CargoMsg.Cargo_Days')" :value="0" />
                          <el-option :label="$t('CargoMsg.Cargo_Month')" :value="1" />
                        </el-select>
                        <el-tooltip v-if="item.siDayUnit === 1" :content="$t('CargoMsg.Cargo_FinanceMonthUnitTip')" placement="top">
                          <i class="el-icon-warning" style="margin-left: 2px;color: #E6A23C;font-size: 14px;" />
                        </el-tooltip>
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('CargoMsg.Cargo_AirExport')">
                        <el-checkbox v-model="item.ae" no="ae" :disabled="!form.autoFinanceSubmit" @change="chargeFinanceLobChecked(SystemConstants.AE.code, item)" />
                      </el-form-item>
                      <el-form-item>
                        <el-select v-model="item.aeDateType" no="aeDateType" style="width:100px;" :disabled="!(form.autoFinanceSubmit && item.ae)">
                          <el-option
                            v-for="item in financeEtdDateType"
                            :key="item.code"
                            :label="item.code"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <el-select style="width:100px;" :value="0" no="aePone" :disabled="!(form.autoFinanceSubmit && item.ae)">
                          <el-option :label="$t('CargoMsg.Cargo_GreaterThan')" :value="0" />
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <auto-number-input v-model="item.aeDay" style="width: 100px;" no="aeDay" :disabled="!(form.autoFinanceSubmit && item.ae)" :enforce-min="true" :min="0" />
                      </el-form-item>
                      <el-form-item>
                        <el-select v-model="item.aeDayUnit" no="aeDayUnit" style="width:70px;" :disabled="!(form.autoFinanceSubmit && item.ae)">
                          <el-option :label="$t('CargoMsg.Cargo_Days')" :value="0" />
                          <el-option :label="$t('CargoMsg.Cargo_Month')" :value="1" />
                        </el-select>
                        <el-tooltip v-if="item.aeDayUnit === 1" :content="$t('CargoMsg.Cargo_FinanceMonthUnitTip')" placement="top">
                          <i class="el-icon-warning" style="margin-left: 2px;color: #E6A23C;font-size: 14px;" />
                        </el-tooltip>
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('CargoMsg.Cargo_AirImport')">
                        <el-checkbox v-model="item.ai" no="ai" :disabled="!form.autoFinanceSubmit" @change="chargeFinanceLobChecked(SystemConstants.AI.code, item)" />
                      </el-form-item>
                      <el-form-item>
                        <el-select v-model="item.aiDateType" no="aiDateType" style="width:100px;" :disabled="!(form.autoFinanceSubmit && item.ai)">
                          <el-option
                            v-for="item in financeAtdDateType"
                            :key="item.code"
                            :label="item.code"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <el-select style="width:100px;" :value="0" no="aiPone" :disabled="!(form.autoFinanceSubmit && item.ai)">
                          <el-option :label="$t('CargoMsg.Cargo_GreaterThan')" :value="0" />
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <auto-number-input v-model="item.aiDay" style="width: 100px;" no="aiDay" :disabled="!(form.autoFinanceSubmit && item.ai)" :enforce-min="true" :min="0" />
                      </el-form-item>
                      <el-form-item>
                        <el-select v-model="item.aiDayUnit" no="aiDayUnit" style="width:70px;" :disabled="!(form.autoFinanceSubmit && item.ai)">
                          <el-option :label="$t('CargoMsg.Cargo_Days')" :value="0" />
                          <el-option :label="$t('CargoMsg.Cargo_Month')" :value="1" />
                        </el-select>
                        <el-tooltip v-if="item.aiDayUnit === 1" :content="$t('CargoMsg.Cargo_FinanceMonthUnitTip')" placement="top">
                          <i class="el-icon-warning" style="margin-left: 2px;color: #E6A23C;font-size: 14px;" />
                        </el-tooltip>
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('CargoMsg.Cargo_RailwayExport')">
                        <el-checkbox v-model="item.re" no="re" :disabled="!form.autoFinanceSubmit" @change="chargeFinanceLobChecked(SystemConstants.RE.code, item)" />
                      </el-form-item>
                      <el-form-item>
                        <el-select v-model="item.reDateType" no="reDateType" style="width:100px;" :disabled="!(form.autoFinanceSubmit && item.re)">
                          <el-option
                            v-for="item in financeEtdDateType"
                            :key="item.code"
                            :label="item.code"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <el-select style="width:100px;" :value="0" no="rePone" :disabled="!(form.autoFinanceSubmit && item.re)">
                          <el-option :label="$t('CargoMsg.Cargo_GreaterThan')" :value="0" />
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <auto-number-input v-model="item.reDay" style="width: 100px;" no="reDay" :disabled="!(form.autoFinanceSubmit && item.re)" :enforce-min="true" :min="0" />
                      </el-form-item>
                      <el-form-item>
                        <el-select v-model="item.reDayUnit" no="reDayUnit" style="width:70px;" :disabled="!(form.autoFinanceSubmit && item.re)">
                          <el-option :label="$t('CargoMsg.Cargo_Days')" :value="0" />
                          <el-option :label="$t('CargoMsg.Cargo_Month')" :value="1" />
                        </el-select>
                        <el-tooltip v-if="item.reDayUnit === 1" :content="$t('CargoMsg.Cargo_FinanceMonthUnitTip')" placement="top">
                          <i class="el-icon-warning" style="margin-left: 2px;color: #E6A23C;font-size: 14px;" />
                        </el-tooltip>
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('CargoMsg.Cargo_RailwayImport')">
                        <el-checkbox v-model="item.ri" no="ri" :disabled="!form.autoFinanceSubmit" @change="chargeFinanceLobChecked(SystemConstants.RI.code, item)" />
                      </el-form-item>
                      <el-form-item>
                        <el-select v-model="item.riDateType" no="riDateType" style="width:100px;" :disabled="!(form.autoFinanceSubmit && item.ri)">
                          <el-option
                            v-for="item in financeAtdDateType"
                            :key="item.code"
                            :label="item.code"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <el-select style="width:100px;" :value="0" no="riPone" :disabled="!(form.autoFinanceSubmit && item.ri)">
                          <el-option :label="$t('CargoMsg.Cargo_GreaterThan')" :value="0" />
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <auto-number-input v-model="item.riDay" style="width: 100px;" no="riDay" :disabled="!(form.autoFinanceSubmit && item.ri)" :enforce-min="true" :min="0" />
                      </el-form-item>
                      <el-form-item>
                        <el-select v-model="item.riDayUnit" no="riDayUnit" style="width:70px;" :disabled="!(form.autoFinanceSubmit && item.ri)">
                          <el-option :label="$t('CargoMsg.Cargo_Days')" :value="0" />
                          <el-option :label="$t('CargoMsg.Cargo_Month')" :value="1" />
                        </el-select>
                        <el-tooltip v-if="item.riDayUnit === 1" :content="$t('CargoMsg.Cargo_FinanceMonthUnitTip')" placement="top">
                          <i class="el-icon-warning" style="margin-left: 2px;color: #E6A23C;font-size: 14px;" />
                        </el-tooltip>
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('CargoMsg.Cargo_IntegratedJob')">
                        <el-checkbox v-model="item.ie" no="ie" :disabled="!form.autoFinanceSubmit" @change="chargeFinanceLobChecked(SystemConstants.IE.code, item)" />
                      </el-form-item>
                      <el-form-item>
                        <el-select v-model="item.ieDateType" no="riDateType" style="width:150px;" :disabled="!(form.autoFinanceSubmit && item.ie)">
                          <el-option
                            v-for="item in ieDateType"
                            :key="item.code"
                            :label="item.code"
                            :value="item.value"
                          />
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <el-select style="width:100px;" :value="0" no="iePone" :disabled="!(form.autoFinanceSubmit && item.ie)">
                          <el-option :label="$t('CargoMsg.Cargo_GreaterThan')" :value="0" />
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <auto-number-input v-model="item.ieDay" style="width: 100px;" no="riDay" :disabled="!(form.autoFinanceSubmit && item.ie)" :enforce-min="true" :min="0" />
                      </el-form-item>
                      <el-form-item>
                        <el-select v-model="item.ieDayUnit" no="ieDayUnit" style="width:70px;" :disabled="!(form.autoFinanceSubmit && item.ie)">
                          <el-option :label="$t('CargoMsg.Cargo_Days')" :value="0" />
                          <el-option :label="$t('CargoMsg.Cargo_Month')" :value="1" />
                        </el-select>
                        <el-tooltip v-if="item.ieDayUnit === 1" :content="$t('CargoMsg.Cargo_FinanceMonthUnitTip')" placement="top">
                          <i class="el-icon-warning" style="margin-left: 2px;color: #E6A23C;font-size: 14px;" />
                        </el-tooltip>
                      </el-form-item>
                    </div>
                  </div>
                  <div style="padding-bottom: 5px" />
                </div>

              </el-form>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getUserInfo } from '@/utils/auth'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import { queryAutoLockFunc, saveAutoLockFunc } from '@/api/booking/job'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import lodash from 'lodash'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'ServiceLockSetting',
  components: {
    AutoNumberInput,
    CargoAdvanceSelect
  },
  data() {
    return {
      SystemConstants,
      loading: false,
      isZh: this.$store.getters.language === 'zh',
      activeTabName: 'lockSetting',
      selectTypeNames: TYPE_NAMES,
      form: {
        useParent: false,
        branchId: 1,
        autoLock: false,
        day: 0,
        autoSubmit: false,
        se: false,
        si: false,
        ae: false,
        ai: false,
        re: false,
        ri: false,
        seDateType: 'ETD',
        siDateType: 'ETA',
        aeDateType: 'ETD',
        aiDateType: 'ETA',
        reDateType: 'ETD',
        riDateType: 'ETA',
        seDay: 0,
        siDay: 0,
        aeDay: 0,
        aiDay: 0,
        reDay: 0,
        riDay: 0,
        autoFinanceSubmit: false,
        financeDay: 0,
        financeSetting: [],
        pollingFrequency: 0
      },
      financeFrom: {
        num: 0,
        checked: false,
        incoTerm: [],
        customJobType: [],
        se: false,
        si: false,
        ae: false,
        ai: false,
        re: false,
        ri: false,
        ie: false,
        seDateType: 'ETD',
        siDateType: 'ATD',
        aeDateType: 'ETD',
        aiDateType: 'ATD',
        reDateType: 'ETD',
        riDateType: 'ATD',
        ieDateType: 'ATD',
        seDay: 0,
        siDay: 0,
        aeDay: 0,
        aiDay: 0,
        reDay: 0,
        riDay: 0,
        ieDay: 0,
        seDayUnit: 0,
        siDayUnit: 0,
        aeDayUnit: 0,
        aiDayUnit: 0,
        reDayUnit: 0,
        riDayUnit: 0,
        ieDayUnit: 0,
        pollingFrequency: 0,
        financeDay: 0
      },
      financeSetting: [],
      incoTermList: [],
      etdDateType: [{ code: 'ETD', value: 'ETD' }],
      atdDateType: [{ code: 'ATD', value: 'ATD' }],
      ieDateType: [{ code: 'ATD', value: 'ATD' }, { code: this.$t('CargoMsg.Cargo_BusinessDate'), value: 'BUSINESS_DATE' }, { code: 'ETA', value: 'ETA' }],
      etaDateType: [{ code: 'ETA', value: 'ETA' }],
      financeEtdDateType: [{ code: 'ETD', value: 'ETD' }, { code: 'ETA', value: 'ETA' }],
      financeAtdDateType: [{ code: 'ATD', value: 'ATD' }, { code: 'ETA', value: 'ETA' }]
    }
  },
  computed: {
    currentOfficeList() {
      return getUserInfo().currentUserOfficeList
    }
  },
  async created() {
    await this.init()
    this.queryHandler()
  },
  methods: {
    async init() {
      this.incoTermList = []
      const incoTerms = await getSpecificBasicData(basicCacheKeys.basic_data_IncoTerm)
      if (incoTerms && incoTerms.length > 0) {
        const all = {
          code: 'ALL',
          name: this.$t('CargoMsg.Cargo_All'),
          localName: this.$t('CargoMsg.Cargo_All')
        }
        this.incoTermList.push(all)
        for (const item of incoTerms) {
          this.incoTermList.push(item)
        }
      }
    },
    handleClick() {},
    changeAutoSubmit() {
      if (this.form.autoSubmit) return
      this.initAutoSubmitForm()
    },
    chargeLobChecked(lob) {
      if (SystemConstants.SE.code === lob && !this.form.se) {
        this.form.seDay = 0
      }
      if (SystemConstants.SI.code === lob && !this.form.si) {
        this.form.siDay = 0
      }
      if (SystemConstants.AE.code === lob && !this.form.ae) {
        this.form.aeDay = 0
      }
      if (SystemConstants.AI.code === lob && !this.form.ai) {
        this.form.aiDay = 0
      }
      if (SystemConstants.RE.code === lob && !this.form.re) {
        this.form.reDay = 0
      }
      if (SystemConstants.RI.code === lob && !this.form.ri) {
        this.form.riDay = 0
      }
      if (SystemConstants.RI.code === lob && !this.form.ri) {
        this.form.riDay = 0
      }
    },
    chargeFinanceLobChecked(lob, item) {
      if (SystemConstants.SE.code === lob && !item.se) {
        item.seDay = 0
      }
      if (SystemConstants.SI.code === lob && !item.si) {
        item.siDay = 0
      }
      if (SystemConstants.AE.code === lob && !item.ae) {
        item.aeDay = 0
      }
      if (SystemConstants.AI.code === lob && !item.ai) {
        item.aiDay = 0
      }
      if (SystemConstants.RE.code === lob && !item.re) {
        item.reDay = 0
      }
      if (SystemConstants.RI.code === lob && !item.ri) {
        item.riDay = 0
      }
      if (SystemConstants.IE.code === lob && !item.ie) {
        item.ieDay = 0
      }
    },
    initForm() {
      this.form.autoLock = false
      this.form.useParent = false
      this.form.day = 0
      this.form.autoSubmit = false
      this.form.autoFinanceSubmit = false
      this.initAutoSubmitForm()
      this.changeFinanceAutoSubmit()
    },
    changeFinanceAutoSubmit() {
      this.form.financeDay = 0
      this.form.pollingFrequency = 0
      this.financeSetting = []
    },
    initAutoSubmitForm() {
      this.form.se = false
      this.form.si = false
      this.form.ae = false
      this.form.ai = false
      this.form.re = false
      this.form.ri = false
      this.form.seDay = 0
      this.form.siDay = 0
      this.form.aeDay = 0
      this.form.aiDay = 0
      this.form.reDay = 0
      this.form.riDay = 0
    },
    fillForm(data) {
      this.form.autoLock = data.autoLock
      this.form.useParent = data.useParent
      this.form.day = data.day
      this.form.autoSubmit = data.autoSubmit
      this.form.se = data.se
      this.form.si = data.si
      this.form.ae = data.ae
      this.form.ai = data.ai
      this.form.re = data.re
      this.form.ri = data.ri
      this.form.seDay = data.seDay
      this.form.siDay = data.siDay
      this.form.aeDay = data.aeDay
      this.form.aiDay = data.aiDay
      this.form.reDay = data.reDay
      this.form.riDay = data.riDay
      this.form.autoFinanceSubmit = data.autoFinanceSubmit
      this.form.financeDay = data.financeDay
      this.form.pollingFrequency = data.pollingFrequency
      this.financeSetting = []
      if (data.financeSetting) {
        const financeSetting = JSON.parse(data.financeSetting)
        // 兼容历史数据：单位字段缺失时默认按天
        const unitFields = ['seDayUnit', 'siDayUnit', 'aeDayUnit', 'aiDayUnit', 'reDayUnit', 'riDayUnit', 'ieDayUnit']
        for (const item of financeSetting) {
          for (const field of unitFields) {
            if (item[field] == null) {
              item[field] = 0
            }
          }
        }
        this.financeSetting = financeSetting
      }
    },
    // 应用总公司
    applyHq() {
      this.loading = getLoading4Cxt()
      const data = {
        branchId: this.form.branchId,
        useParent: this.form.useParent,
        autoLock: false,
        autoSubmit: false,
        day: 0
      }
      saveAutoLockFunc(data).then(res => {
        this.queryHandler()
      }).finally((e) => {
        this.loading.close()
      })
    },
    toSave() {
      if (this.form.autoLock && (this.form.day < 3 || this.form.day > 120)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_LockTheNumberOfDeferredDays'))
        return
      }
      this.form.day = this.form.day || 0
      this.form.financeSetting = ''
      if (this.financeSetting) {
        this.form.financeSetting = JSON.stringify(this.financeSetting)
      }
      this.loading = getLoading4Cxt()
      saveAutoLockFunc(this.form).then(res => {
        this.$message.success(this.$t('Message.SavedSuccessfully'))
      }).finally((e) => {
        this.loading.close()
      })
    },
    // 添加财务配置
    toFinanceAdd() {
      if (!this.financeSetting) {
        this.financeSetting = []
      }
      const data = lodash.cloneDeep(this.financeFrom)
      data.num = this.financeSetting.length + 1
      this.financeSetting.push(data)
    },
    // 删除财务配置
    toFinanceDelete() {
      if (!this.financeSetting) {
        return
      }
      const finances = this.financeSetting.filter(p => p.checked)
      if (!finances || finances.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const list = []
      let num = 0
      for (const data of this.financeSetting) {
        if (!data.checked) {
          num++
          data.num = num
          list.push(data)
        }
      }
      this.financeSetting = list
    },
    // 更改分公司
    changeBranch() {
      this.queryHandler()
    },
    queryHandler() {
      this.loading = getLoading4Cxt()
      const data = { branchId: this.form.branchId }
      queryAutoLockFunc(data).then(res => {
        const d = res.data
        this.initForm()
        if (d) {
          this.fillForm(d)
        }
      }).finally((e) => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.service-lock-setting{
  .title{
    display: inline-block;
    position: relative;
    padding-left: 15px;
    margin-bottom: 10px;
  }
  .title:before {
    content: '';
    position: absolute;
    width: 4px;
    top: 0;
    left: 0;
    bottom: 0;
    background-color: #1F75D5;
  }
}
.scrollable-div {
  width: 670px;
  height: 330px;
  overflow-y: auto;
  border: 1px solid #ccc;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 8px;
}
/* 定制滚动条样式 */
.scrollable-div::-webkit-scrollbar {
  width: 6px; /* 设置滚动条的宽度 */
}
.scrollable-div::-webkit-scrollbar-track {
  background-color: transparent; /* 滚动条轨道透明 */
}
.scrollable-div::-webkit-scrollbar-thumb {
  background-color: #888; /* 滚动条滑块颜色 */
  border-radius: 3px; /* 滚动条滑块圆角 */
}
.scrollable-div::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* 滚动条滑块悬停时的颜色 */
}
</style>
